import classNames from "classnames";
import { FC, HTMLAttributes } from "react";

import styles from "./CustomLabel.module.scss";

export const CustomLabel:FC<{
  title: string;
  type: "table-headers" | "table-data";
} & HTMLAttributes<HTMLDivElement>> = ({
    title,
    type,
    ...rest
}) => {
  return (
    <div className={classNames(styles.root, styles[type])} {...rest}>
      {title}
    </div>
  );
}